import React from 'react';
function getName(driver) {
    if (!driver) {
        return '';
    }
    if (driver.lastName) {
        return driver.firstName + ' ' + driver.lastName;
    }

    return driver.firstName;
}

export function DriverName({ driver, className }) {
    return (<span className={className}>{getName(driver)}</span>);
}


// WEBPACK FOOTER //
// ./src/components/sidebarOrders/order/DriverName.js